/** WIMP 合同级 H5：true=隐藏顶部「订单中心」，缺省/ false=展示 */
export const H5_HIDE_ORDER_CENTER_KEY = 'S_hideOrderCenter';

export function isH5PermissionTruthy(value: unknown): boolean {
  if (value === true || value === 1) {
    return true;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'y';
  }
  return false;
}

/**
 * 读取 H5 开关；配置缺失时返回 defaultWhenMissing。
 */
export function isH5PermissionEnabled(
  permissions: Record<string, unknown> | undefined,
  key: string,
  defaultWhenMissing: boolean,
): boolean {
  if (!permissions || !Object.prototype.hasOwnProperty.call(permissions, key)) {
    return defaultWhenMissing;
  }
  const value = permissions[key];
  if (value === undefined || value === null || value === '') {
    return defaultWhenMissing;
  }
  return isH5PermissionTruthy(value);
}

/** WIMP 数字开关：1=开，0=关（合同级配置统一用 0/1，不用 boolean） */
export function isH5ZeroOneSwitchEnabled(value: unknown): boolean {
  return value === 1 || value === '1';
}

/**
 * 读取 WIMP 0/1 开关；缺省或未配置时返回 defaultWhenMissing。
 */
export function isH5ZeroOneSwitchOn(
  permissions: Record<string, unknown> | undefined,
  key: string,
  defaultWhenMissing = false,
): boolean {
  if (!permissions || !Object.prototype.hasOwnProperty.call(permissions, key)) {
    return defaultWhenMissing;
  }
  const value = permissions[key];
  if (value === undefined || value === null || value === '') {
    return defaultWhenMissing;
  }
  return isH5ZeroOneSwitchEnabled(value);
}

/** 顶部「订单中心」是否展示：S_hideOrderCenter=true 时隐藏，默认展示 */
export function isOrderCenterVisible(permissions: Record<string, unknown> | undefined): boolean {
  return !isH5PermissionEnabled(permissions, H5_HIDE_ORDER_CENTER_KEY, false);
}
